import React, { useEffect, useState } from 'react';
import { AutobizBanner } from 'autobiz-strap';
import { Auth } from '../../../config/configuration/react';
import { REACT_APP_APIOFFICE } from '../../../config';

const Banner = () => {
  const token = Auth.token();
  const preferredLanguage = Auth.preferredLanguage();
  const country = (Auth.country() || 'en').toLowerCase();
  const [bannerData, setBannerData] = useState(null);

  useEffect(() => {
    fetch(`${REACT_APP_APIOFFICE}/cms/banner?locale=${preferredLanguage}&app=autobizCarcheck&country=${country}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data && Object.keys(data).length > 0) {
          setBannerData({
            textColor: data?.textColor,
            backgroundColor: data?.backgroundColor,
            align: data?.align,
            content: data?.content,
          });
        }
      })
      .catch((err) => console.error(err));
  }, [token, preferredLanguage, country]);

  const hasBannerData = bannerData && Object.values(bannerData).some((value) => value);

  return (
    <>
      {hasBannerData && (
        <AutobizBanner textColor={bannerData.textColor} backgroundColor={bannerData.backgroundColor} align="center">
          {bannerData.content}
        </AutobizBanner>
      )}
    </>
  );
};

export default Banner;
